const canvas = document.getElementById("box4-video_canvas");
const context = canvas.getContext("2d");

const t1 = document.querySelector('.box4-info .t1');
const t2 = document.querySelector('.box4-info .t2');

const box4 = document.querySelector("#box4");
const box4m1 = document.querySelector(".box4-m1");
const box4m2 = document.querySelector(".box4-m2");
const box5 = document.querySelector(".box5");
const box9 = document.querySelector(".box9");
const box10 = document.querySelector(".box10");

const skip1 =  document.querySelector(".box3-div .item1 .div1 .left");
const skip2 =  document.querySelector(".box3-div .item1 .div1 .right");
const skip3 =  document.querySelector(".box3-div .item1 .div2 .left");
const skip4 =  document.querySelector(".box3-div .item1 .div2 .right");
const skip5 =  document.querySelector(".box3-div .item1 .div3 .left");
const skip6 =  document.querySelector(".box3-div .item1 .div3 .right");
const skip7 =  document.querySelector(".box3-div .item2 .s1 .s1-div1");
const skip8 =  document.querySelector(".box3-div .item2 .s2 .s2-div1");
const skip9 =  document.querySelector(".box3-div .item2 .s1 .s1-div2");
const skip10 =  document.querySelector(".box3-div .item2 .s2 .s2-div2");

const scrollboxUl = document.querySelector("#box7-splide")
const box7SplideArr = document.querySelectorAll("#box7-splide li")

$('.video-but').click(function(){
  
  const videoWidth = $(this).context.dataset.width;
  const videoHeight = $(this).context.dataset.height;
  const videoSrc = $(this).context.dataset.src;

  $(this).parent().css('z-index','1')
  
  let videoCode =`<iframe width="${videoWidth}" height="${videoHeight}" src="https://www.youtube.com/embed/${videoSrc}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`

  $(this).parent().next().append(videoCode);
})


$(function(){ 

  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": function(){
    
      let na4c = 0
      const frameCount = 72;
      const images = []

      canvas.width = 2160;
      canvas.height = 1250;

      let currentFrame = index => (
        `https://cdn.shopify.com/s/files/1/0604/6410/3654/files/02-03_${(index).toString().padStart(5, '0')}.jpg`
      );

      for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      images[0].onload = render;
          
      function render() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(images[na4c], 0, 0, canvas.width, canvas.height); 
      }

      ScrollTrigger.create({
        trigger: '.box4',
        start: 'top top',
        end:'+=200% bottom',
        scrub: true,
        pin:true,
        onUpdate(self){
            let imgIndex = Math.ceil(self.progress * frameCount);
            na4c = imgIndex - 1
            if (na4c < 0) na4c = 0
            if(na4c<=frameCount){ render() }
            if(na4c>45) {
              t1.classList.remove('active');
              t2.classList.add('active');
            }else{
              t1.classList.add('active');
              t2.classList.remove('active');
            }
            
        }
      })

      ScrollTrigger.create({
        trigger: '.box7',
        start: 'top top',
        end:'+=150%',
        scrub: true,
        pin:true,
        onUpdate(self){
    
            let imgIndex = Math.ceil(self.progress * 4);
    
            if(imgIndex == 1){
              scrollboxUl.style.transform = 'translate(0%)'
            }
            if(imgIndex == 2){
              scrollboxUl.style.transform = 'translate(-102%)'
            }
            if(imgIndex == 3){
              scrollboxUl.style.transform = 'translate(-204%)'
            }
            if(imgIndex == 4){
              scrollboxUl.style.transform = 'translate(-306%)'
            }
            
        }
      })
  
    },
    "(min-width: 751px) and (max-width: 1024px)": function(){
      ScrollTrigger.create({
        trigger: '.scrollbox',
        start: '-150px top',
        end:'+=100%',
        scrub: true,
        pin:true,
        onUpdate(self){
    
            let imgIndex = Math.ceil(self.progress * 4);
    
            if(imgIndex == 1){
              scrollboxUl.style.transform = 'translate(0%)'
            }
            if(imgIndex == 2){
              scrollboxUl.style.transform = 'translate(-102%)'
            }
            if(imgIndex == 3){
              scrollboxUl.style.transform = 'translate(-204%)'
            }
            if(imgIndex == 4){
              scrollboxUl.style.transform = 'translate(-306%)'
            }
            
        }
      })
    },
    "(max-width: 750px)": function(){
      ScrollTrigger.create({
        trigger: '.scrollbox',
        start: '-100px top',
        end:'200% center',
        scrub: true,
        pin:true,
        onUpdate(self){
    
            let imgIndex = Math.ceil(self.progress * 4);
    
            if(imgIndex == 1){
              scrollboxUl.style.transform = 'translate(0%)'
            }
            if(imgIndex == 2){
              scrollboxUl.style.transform = 'translate(-102%)'
            }
            if(imgIndex == 3){
              scrollboxUl.style.transform = 'translate(-204%)'
            }
            if(imgIndex == 4){
              scrollboxUl.style.transform = 'translate(-306%)'
            }
            
        }
      })
    }
  })

const windowHeight = window.innerHeight;

// 点击滚到到元素位置
function distanceToTop(clickEl,GoEl,Extension = 0){
  clickEl.addEventListener('click',()=>{
    
    let distanceToTop  = GoEl
    if(Extension){
      distanceToTop+=Extension
    }
    
    window.scrollTo({top:distanceToTop})
    // window.scrollTo({top:distanceToTop,behavior: "smooth"})
  })
}
distanceToTop(skip1,box4.offsetTop);
distanceToTop(skip2,box4.offsetTop,windowHeight);
distanceToTop(skip3,box5.offsetTop);
distanceToTop(skip4,box4.offsetTop,windowHeight);
distanceToTop(skip5,box4.offsetTop,windowHeight);
distanceToTop(skip6,box4.offsetTop,windowHeight);
distanceToTop(skip7,box10.offsetTop,);
distanceToTop(skip8,box9.offsetTop,);
distanceToTop(skip9,box4m1.offsetTop,-20);
distanceToTop(skip10,box4m2.offsetTop,-20);
})

const box8TabImg = document.querySelectorAll(".box8-b .left picture");
const box8TabItem = document.querySelectorAll(".box8-b .right .right-li");

const box11TabImg = document.querySelectorAll(".box11-b .right .right-t>a>picture");
const box11TabItem = document.querySelectorAll(".box11-b .right .right-b>div");

box8TabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{

    box8TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box8TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box8TabItem[index].classList.add("active");
    box8TabImg[index].classList.add("active");
  })

  link.addEventListener('click', (e)=>{

    box8TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box8TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box8TabItem[index].classList.add("active");
    box8TabImg[index].classList.add("active");
  })

})

box11TabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{

    box11TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box11TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box11TabItem[index].classList.add("active");
    box11TabImg[index].classList.add("active");
  })

  link.addEventListener('click', (e)=>{

    box11TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box11TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box11TabItem[index].classList.add("active");
    box11TabImg[index].classList.add("active");
  })

})